import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import React from "react";
import * as actions from "../actions";
import statusViewStateToProps from "../selectors";
import StatusLayout from "./StatusLayout";

class StatusView extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
    formDataFiltered: PropTypes.arrayOf(
      PropTypes.shape({
        hakai_id: PropTypes.string,
        start_dt: PropTypes.string,
        processing_stage: PropTypes.string,
        status: PropTypes.string,
        process_error: PropTypes.string,
        filename: PropTypes.string,
        device_sn: PropTypes.string
      })
    ).isRequired,
    actions: PropTypes.shape({
      setSearchText: PropTypes.func.isRequired,
      setRangeFilter: PropTypes.func.isRequired,
      setStageFilter: PropTypes.func.isRequired,
      setSearchFilter: PropTypes.func.isRequired,
      setShowWirewalker: PropTypes.func.isRequired,
      submissionDataFetchIfNeeded: PropTypes.func.isRequired,
      closeDetailsModal: PropTypes.func.isRequired,
      setDetailsModalData: PropTypes.func.isRequired,
      updateFiltersFromQuery: PropTypes.func.isRequired
    }).isRequired
  };

  componentDidMount() {
    document.title = "CTD Processing Status";
    // eslint-disable-next-line react/prop-types
    if (
      this.props.location.search !== "?" &&
      this.props.location.search !== ""
    ) {
      // eslint-disable-next-line react/prop-types
      const urlParams = new URLSearchParams(
        this.props.location.search.replace("?", "")
      );
      this.props.actions.updateFiltersFromQuery(urlParams);
    }
    this.props.actions.submissionDataFetchIfNeeded();
  }

  handleRowClick(rowIndex) {
    if (!this.props.formDataFiltered) return false;
    this.props.actions.setDetailsModalData({
      modalData: this.props.formDataFiltered[rowIndex]
    });
    return true;
  }

  handleFilesRefreshClick() {
    this.props.actions.submissionDataFetchIfNeeded();
  }

  render() {
    return (
      <StatusLayout
        {...this.props}
        onRefreshClick={() => this.handleFilesRefreshClick()}
        onRangeChange={instr => {
          this.props.actions.setRangeFilter(instr);
        }}
        onStageChange={instr => {
          this.props.actions.setStageFilter(instr);
        }}
        onChangeSearchText={v => this.props.actions.setSearchText(v)}
        onFilterChange={v => this.props.actions.setSearchFilter(v)}
        onShowWirewalkerChange={v => this.props.actions.setShowWirewalker(v)}
        onStatusRowClick={(e, i) => this.handleRowClick(i)}
        onDetailsModalClose={() => this.props.actions.closeDetailsModal()}
        onFilterClear={() => this.props.actions.setSearchFilter("")}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(statusViewStateToProps, mapDispatchToProps)(StatusView);
